import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function BreadcrumbSection() {
  return <div className="flex items-center text-sm text-gray-500 mb-8" data-id="element-1846">
      <a href="/" className="hover:text-orange transition-colors" data-id="element-1847">
        Home
      </a>
      <ChevronRightIcon className="w-4 h-4 mx-2" data-id="element-1848" />
      <span className="text-navy font-semibold" data-id="element-1849">Fast Wire EDM (Moly)</span>
    </div>;
}